import {
  ERiskSummaryType,
  IJBACombinedRisk,
  IJbaRiskSummary,
  IJbaScoreCount,
  IRiskAccuracy,
  IRiskRecord,
  IRiskSummary,
} from "@/types/index";

export class RiskRecord implements IRiskRecord {
  private readonly _data!: IRiskRecord;
  type: ERiskSummaryType = ERiskSummaryType.Default;
  icon = "other";
  name = "Unspecified";

  constructor(
    data: IRiskRecord | RiskRecord,
    mappings: {
      name: string;
      icon: string;
      type: ERiskSummaryType;
    }
  ) {
    if (data instanceof RiskRecord) {
      return data;
    }
    Object.assign(this, mappings);
    this._data = data;
  }

  get data() {
    return this._data;
  }

  get isDefault(): boolean {
    return this.type === ERiskSummaryType.Default;
  }

  get isJBA(): boolean {
    return this.type === ERiskSummaryType.JBA;
  }

  get isFloodClimateChange(): boolean {
    return this.type === ERiskSummaryType.FloodClimateChange;
  }

  get Accuracy(): IRiskAccuracy {
    return this._data.Accuracy;
  }

  get RiskSummary(): IRiskSummary {
    return this.isJBA || this.isFloodClimateChange
      ? {
          Score: (this._data.RiskSummary as IJbaRiskSummary).JBACombinedRisk
            .CombinedScore,
          RAGScore: (this._data.RiskSummary as IJbaRiskSummary).JBACombinedRisk
            .RAGScore,
        }
      : this._data.RiskSummary;
  }

  get JBACombinedRisk(): IJBACombinedRisk | undefined {
    return (this._data.RiskSummary as IJbaRiskSummary).JBACombinedRisk;
  }

  get ragScore() {
    return this.RiskSummary.RAGScore;
  }

  get score() {
    return this.RiskSummary.Score;
  }

  get scoreCounts(): IJbaScoreCount[] {
    return this.isJBA
      ? (this._data.RiskSummary as IJbaRiskSummary).JBAScoreCount
      : [];
  }

  get period(): string {
    return this.isJBA ? (this._data.RiskSummary as IJbaRiskSummary).Period : "";
  }

  get html(): string {
    return this._data.moreInfo || "";
  }
}
